import { render, staticRenderFns } from "./AudioViewer.vue?vue&type=template&id=6c6d443b&scoped=true&"
import script from "./AudioViewer.vue?vue&type=script&lang=js&"
export * from "./AudioViewer.vue?vue&type=script&lang=js&"
import style0 from "./AudioViewer.vue?vue&type=style&index=0&id=6c6d443b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6d443b",
  null
  
)

export default component.exports